import React from 'react';
import './SoftwareList.css';

import Icon from '../../../components/Icon/Icon';
import CurvedBottom from '../../../components/CurvedBottom/CurvedBottom';
import DocumentLinks from '../../../components/DocumentLinks/DocumentLinks';

import SoftwareItem from './SoftwareItem';

const softwareList = ( props ) => {
	const appList = [];
	
	if( props.list ) {
		props.list.installed.map( app => {
			appList.push( <SoftwareItem key={ app.id } { ...app } /> );
			return null;
		});
		
		props.list.canPush.map( app => {
			appList.push( <SoftwareItem key={ app.id } { ...app } /> );
			return null;
		});
		
		props.list.download.map( app => {
			appList.push( <SoftwareItem key={ app.id } { ...app } /> );
			return null;
		});
	}
	
	return (
		<section id="SoftwareList" className="bg-color-2">
			<h2>Pre-Approved <span>Software</span> List</h2>
			<p className="titleNote">
				Blessed with Michael's seal of approval
			</p>
			
			<div className="list-info">
				<p>
					Many pre-approved programs are automatically installed and updated on all IDSI computers. There are other programs that are pre-approved and can be pushed to your computer at any time.
				</p>
				<Icon icon="it.software" title="Installed Software" />
			</div>
			
			<div className="docs-info">
				<p className="docs-info-text">
					If you need something not already installed, talk with Michael and he can verify it is legal and safe, then either push it to your computer or coordinate the install with you. The following software below is pre-approved.
					<br />
					If you need more information on the process of installing, or the full list of pre-approved software, click the download icon.
				</p>
				<DocumentLinks docs={ props.docs } />
			</div>
			
			<p className="titleNote">
				Pre-Approved Software
			</p>
			
			<div className="scroll-list">
				<div className="scroll-list-inner">
					{ appList }
					{ appList }
				</div>
				<CurvedBottom />
			</div> 
		</section>
	);
};

export default softwareList;



// WEBPACK FOOTER //
// ./src/pages/IT/SoftwareList/SoftwareList.js